var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rubbish-container row-center aife"},[_c('span',{staticClass:"trash",style:(_vm.ownstyle.trash)},[_c('span',{style:(_vm.ownstyle.trash)},[_c('figure',{staticClass:"tapa",style:(_vm.ownstyle.trash)})]),_vm._v(" "),_c('i')])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-974ca0c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/icons/rubbish.vue
// module id = null
// module chunks = 